import React, { ReactNode } from "react";
import { CpIcon } from "@components";

export type GroupProps = {
  name?: string;
  icon?: string | ReactNode;
  count?: number;
  isSeparator?: boolean;
  showCount?: boolean;
};

export const Group = (props: GroupProps) => {
  const { name, icon, count, isSeparator, showCount = true } = props;

  if (isSeparator) {
    return <div className="cp-select-component__group-separator" />;
  }

  if (!name && !icon) {
    return null;
  }

  return (
    <div className="cp-select-component__group">
      <div className="cp-select-component__group-line" />
      <div className="cp-select-component__group-content">
        {icon && typeof icon === "string" ? (
          <CpIcon className="cp-mr-8" name={icon} />
        ) : (
          <span className="cp-select-component__group-custom-image">
            {icon}
          </span>
        )}
        {name}{" "}
        {showCount && (
          <span className="cp-select-component__group-count">
            ({count} results)
          </span>
        )}
      </div>
    </div>
  );
};
